export const calculateVP = (team1_imps, team2_imps, boardCount, t1_penalty = 0, t2_penalty = 0) => {
    // Safety: If boards are 0 or omitted entirely, prevent divide-by-zero
    if (!boardCount || boardCount <= 0) return { vp1: "0.00", vp2: "0.00" };

    const imps1 = parseInt(team1_imps) || 0;
    const imps2 = parseInt(team2_imps) || 0;
    const pen1 = parseFloat(t1_penalty) || 0;
    const pen2 = parseFloat(t2_penalty) || 0;
    
    // Perfect tie before penalties
    if (imps1 === imps2) {
        return {
            vp1: Math.max(0, 10 - pen1).toFixed(2),
            vp2: Math.max(0, 10 - pen2).toFixed(2)
        };
    }

    const M = Math.abs(imps1 - imps2);
    const B = 15 * Math.sqrt(boardCount);
    const TAU = (Math.sqrt(5) - 1) / 2;
    const DENOM = 1 - Math.pow(TAU, 3);

    // Calculate raw winner VP using the WBF Algorithm
    let vpWinner = 10 + 10 * ((1 - Math.pow(TAU, (3 * M) / B)) / DENOM);
    vpWinner = Math.min(20, vpWinner); // Hard cap at 20.00
    
    // Standard WBF implementation rounds to 2 decimal places
    vpWinner = Math.round(vpWinner * 100) / 100;
    const vpLoser = Math.round((20 - vpWinner) * 100) / 100;

    let vp1, vp2;
    if (imps1 > imps2) {
        vp1 = vpWinner;
        vp2 = vpLoser;
    } else {
        vp1 = vpLoser;
        vp2 = vpWinner;
    }

    // Apply Penalties (Ensure VPs don't drop below 0 due to severe penalties)
    vp1 = Math.max(0, vp1 - pen1);
    vp2 = Math.max(0, vp2 - pen2);

    return {
        vp1: vp1.toFixed(2),
        vp2: vp2.toFixed(2)
    };
};

/**
 * Calculates Board-a-Match (BAM) scores for tiebreaks.
 * 1 point for a win, 0.5 for a tie, 0 for a loss.
 * @param {Array} boardMargins - Array of IMP margins per board from Team 1's perspective.
 * (e.g., [3, -5, 0] -> T1 won Bd1, lost Bd2, tied Bd3)
 */
export const calculateBAM = (rawScoreMargins) => {
    let bam1 = 0;
    let bam2 = 0;

    rawScoreMargins.forEach(rawMargin => {
        if (rawMargin > 0) {
            bam1 += 1;
        } else if (rawMargin < 0) {
            bam2 += 1;
        } else {
            bam1 += 0.5;
            bam2 += 0.5;
        }
    });

    return { bam1, bam2 };
};